import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthInput from '../components/auth/AuthInput';
import AuthScreen from '../components/auth/AuthScreen';
import PrimaryButton from '../components/auth/PrimaryButton';
import SecondaryButton from '../components/auth/SecondaryButton';
import { auth } from '../firebase/config';
import { createSession } from '../firebase/session';
import { useSessionStore } from '../store/sessionStore';
import { runAsyncUi } from '../utils/asyncUi';

const Home: React.FC = () => {
    const navigate = useNavigate();
    const [name, setName] = useState('');
    const [joinId, setJoinId] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const getState = useSessionStore(s => s.getState);
    const user = auth.currentUser;

    const handleCreate = async () => {
        if (!user) return;

        await runAsyncUi({
            action: async () => {
                const sessionName = name.trim() || `Sesión ${new Date().toLocaleDateString('es')}`;
                const id = await createSession(sessionName, user.uid, getState());
                navigate(`/session/${id}`);
                return id;
            },
            setLoading,
            setError,
        });
    };

    const handleJoin = () => {
        if (!joinId.trim()) return;
        navigate(`/session/${joinId.trim()}`);
    };

    return (
        <AuthScreen cardWidth={380}>
            <div style={s.logo}>Process Mapper</div>
            <p style={s.userText}>{user?.displayName ?? user?.email ?? 'Anónimo'}</p>

            <div style={s.block}>
                <p style={s.blockTitle}>Nueva sesión</p>
                <AuthInput
                    value={name}
                    onChange={e => setName(e.target.value)}
                    onKeyDown={e => e.key === 'Enter' && handleCreate()}
                    placeholder="Nombre del taller (opcional)"
                />
                <PrimaryButton onClick={handleCreate} disabled={loading}>
                    {loading ? 'Creando…' : '+ Crear sesión'}
                </PrimaryButton>
            </div>

            <div style={{ textAlign: 'center', color: '#ccc', fontSize: 11 }}>— o únete a una existente —</div>

            <div style={s.block}>
                <p style={s.blockTitle}>Unirse con ID</p>
                <AuthInput
                    value={joinId}
                    onChange={e => setJoinId(e.target.value)}
                    onKeyDown={e => e.key === 'Enter' && handleJoin()}
                    placeholder="ID de sesión"
                />
                <SecondaryButton onClick={handleJoin} disabled={!joinId.trim()}>
                    Unirse →
                </SecondaryButton>
            </div>

            {error && <p style={{ color: '#c0392b', fontSize: 12, textAlign: 'center' }}>{error}</p>}

            <button onClick={() => auth.signOut()} style={s.logoutBtn}>
                Cerrar sesión
            </button>
        </AuthScreen>
    );
};

const s: Record<string, React.CSSProperties> = {
    logo: { fontFamily: "'Caveat',cursive", fontSize: 28, fontWeight: 700, color: '#2d7a50', textAlign: 'center' },
    userText: { fontSize: 11, color: '#aaa', textAlign: 'center', marginTop: -14 },
    block: { display: 'flex', flexDirection: 'column', gap: 8 },
    blockTitle: { fontSize: 10, color: '#aaa', textTransform: 'uppercase', letterSpacing: '.07em' },
    logoutBtn: { background: 'none', border: 'none', color: '#ccc', fontSize: 11, cursor: 'pointer', textAlign: 'center' },
};

export default Home;
